import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UtilService, HttpService } from '@app/core';

@Injectable({
	providedIn: 'root'
})
export class AuthGuard implements CanActivate {

	constructor(
		private utilService: UtilService,
		private httpService: HttpService,
		private router: Router
	) { }

	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
		return new Promise(resolve => {
			this.httpService.get('auth/session').then((data) => {
				if (data.logged) {
					this.utilService.setLS('logged', true);
					this.utilService.setLS('user', data.user, true);
					this.utilService.setLS('googleDrive', data.googleDrive, true);
					resolve(true);
				} else {
					this.utilService.setLS('logged', false);
					resolve(false);
				}
			}).catch((error) => {
				this.utilService.setLS('logged', false);
				resolve(false);
			});
		});
	}
}
